import http from './HttpService';
import { API_BASE_CAMPAIGN, API_BASE_CONTENT } from '../../constants/index';
import axios from 'axios';

/**
 * get emails with/without campaigns
 * (if campaign_id in queryParams then return the campaigns
 *  emails otherwise will return emails with campaign)
 */
export function getEmailBrowserListService(queryParams?: string) {
  return http.get(`${API_BASE_CAMPAIGN}get_email_browser_content/?${queryParams}`, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

//* Create new Email with/without campaign
export function createNewEmailService(articles: string, campaignId?: any) {
  let data = new FormData();
  data.append('new_article_ids', articles);
  if (campaignId) data.append('campaign_id', campaignId);
  return http.post(`${API_BASE_CONTENT}curated_articles/`, data);
}

//*  Curate articles to Email with/without Campaign
export function addArticlesToEmailInEmailBrowserService(emailId: any, selectedArticles: any, campaignId?: any) {
  let data = new FormData();
  data.append('email_id', '' + emailId.toString());
  data.append('new_article_ids', '' + selectedArticles);
  if (campaignId) data.append('campaign_id', '' + campaignId.toString());
  return http.post(`${API_BASE_CONTENT}curated_articles/`, data);
}

export function undoCurationFromEmailService(emailId: number, selectedArticles: string) {
  let data = new FormData();
  data.append('version_id', '' + emailId);
  data.append('article_id', '' + selectedArticles);
  return http.post(`${API_BASE_CONTENT}delete_curated_article/`, data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

//Remove email service
export function removeEmailFromEmailBrowserListService(emailId: any, campaignId?: any, generationId?: any) {
  let formData = new FormData();
  if (!generationId) formData.append('email_id', '' + emailId);
  if (campaignId) formData.append('campaign_id', '' + emailId);
  if (generationId) formData.append('generation_id', generationId);
  return http.post(`${API_BASE_CAMPAIGN}delete_email/`, formData, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function updateEmailNameService(name: any, emailId?: any, generationId?: string) {
  let formData = new FormData();
  if (emailId) {
    formData.append('email_id', emailId.toString());
  }
  if (generationId) {
    formData.append('generation_id', generationId.toString());
  }

  formData.append('email_name', '' + name);

  let cancelTokenUpdateEmail: any;
  //Check if there are any previous pending requests
  if (typeof cancelTokenUpdateEmail != typeof undefined) {
    cancelTokenUpdateEmail && cancelTokenUpdateEmail.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenUpdateEmail = axios.CancelToken.source();

  return http.post(`${API_BASE_CAMPAIGN}update_email/`, formData, {
    cancelToken: cancelTokenUpdateEmail.token,
  });
}

//! Above this line are the new changes for WB 4.0

//* SEARCH BROWSER ASSETS LIST -> need to change to email builder when required
export function searchBrowserAssetListService(data: any) {
  return http.get(`${API_BASE_CAMPAIGN}get_asset_browser_content/?search_asset=${data}`, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function searchBrowserAssetListInCampaignService(data: any, campaignId: any) {
  return http.get(`${API_BASE_CAMPAIGN}get_asset_browser_content/?search_asset=${data}&campaign_id=${campaignId}`, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

//*  CREATE NEW VERSION TO AN ASSET
export function createNewDraftForAssetService(assetId: number, selectedArticles: string) {
  let data = new FormData();
  console.log('selecteArticles : ', selectedArticles);
  data.append('asset_id', '' + assetId);
  data.append('new_article_ids', '' + selectedArticles);
  return http.post(`${API_BASE_CONTENT}curated_articles/`, data);
}

export function deleteNewlyCreatedDraftService(version_id: number) {
  let data = new FormData();
  data.append('edition_id', '' + version_id);
  return http.post(`${API_BASE_CAMPAIGN}delete_edition/`, data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

// export function addingCuratedContentUrlService(link: string) {
// let versionId = getVersionId();
//   var data = new FormData();
//   data.append("url", link.toString());
//   data.append("version_id", "" + versionId);
//   return http.post(`${API_BASE_CONTENT}add_article_by_url/`, data, {
//     //headers: { "X-CSRFToken": getCSRFToken() },
//   });
// }

// Fetch specific assets for a campaign

// Create a new email for a specific campaign

//* FETCH BROWSER ASSETS LIST FOR A CAMPAIGN
export function getBrowserAssetsForCampaignService(campaign_id: any) {
  // let versionId = getVersionId();
  return http.get(`${API_BASE_CAMPAIGN}get_asset_browser_content/?campaign_id=${campaign_id}`, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}
